// i18n area 'system' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.pl-PL.meta.json.
import type { enUS } from './system'

export const plPL: typeof enUS = {
  diagnostics: {
    title: 'Diagnostyka',
    subtitle: 'Co jest nie tak, najgorsze najpierw — ta sama soczewka co tvirt diagnose',
    reload: 'Odśwież',
    loadError: 'Nie udało się odczytać diagnozy',
    exportBundle: 'Eksportuj pakiet',
    exportError: 'Nie udało się utworzyć pakietu',
    noProblem: 'Brak problemów w sprawdzonych obszarach',
    nothingInspected: 'NIC nie zostało sprawdzone — to nie jest świadectwo zdrowia',
    inspected: 'Sprawdzone',
    notInspected: 'NIESPRAWDZONE',
    localHint: 'Obszary lokalne węzła (jednostki systemd, journal) czyta się tylko z CLI: tvirt diagnose --area local — droga, gdy API nie odpowiada.',
    thresholds: 'nieudane zadania w ciągu {hours} h, heartbeat opóźniony ponad {seconds} s',
    severity: {
      critical: 'Krytyczny',
      warning: 'Ostrzeżenie',
      unknown: 'Nieznany'
    }
  },
  explorer: {
    title: 'Eksplorator zasobów',
    root: 'Korzeń',
    empty: 'Brak zasobów w tym scope',
    previewHint: 'Należy wybrać obiekt, aby zobaczyć jego podgląd',
    open: 'Otwórz',

    // Deep link ?scope= list CRUD (runda #109), z eksploratora (#143).
    openScoped: 'Otwórz listę w tym scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Template VM',
      ct: 'CT',
      ctTemplate: 'Template CT',
      app: 'Aplikacja',
      overlayNetwork: 'Sieć overlay',
      networkService: 'Usługa sieciowa',
      fabric: 'Fabric',
      subnet: 'Podsieć',
      storage: 'Pula storage',
      disk: 'Dysk',
      catalogFile: 'Plik katalogu',
      ociRegistry: 'Registry OCI',
      ociImage: 'Obraz OCI',
      cephCluster: 'Klaster Ceph',
      backupDestination: 'Cel kopii zapasowych',
      user: 'Użytkownik',
      group: 'Grupa',
      role: 'Rola',
      credential: 'Poświadczenie',
      tag: 'Tag',
      proximityRule: 'Reguła Proximity'
    }
  },
  tags: {
    title: 'Tagi',
    empty: 'Brak tagów',
    add: 'Dodaj tag',
    remove: 'Odepnij',
    name: 'Tag',
    value: 'Wartość',
    save: 'Zapisz',
    saveError: 'Nie można zapisać tagów',
    loadError: 'Nie można wczytać słownika tagów',
    noVocabulary: 'Brak tagów dostępnych dla tego typu zasobu',

    // Tag jednowartościowy, który jest już ustawiony, odpowiada 409: zastąpienie
    // jest zawsze jawne — nigdy niejawna podmiana (projekt, ratyfikacja 2026-07-27).
    overwrite: 'Zastąp bieżącą wartość',

    // System > Tagi, powierzchnia słownika.
    createTitle: 'Utwórz tag',
    editTitle: 'Edytuj tag',
    nameHint: 'Litery, cyfry, kropki, myślniki i podkreślenia — bez ":" i "/"; prefiks tvirt- jest zarezerwowany dla platformy',
    cardinality: 'Liczność',
    cardinalitySingle: 'Jedna wartość',
    cardinalityMultiple: 'Wiele wartości',
    cardinalityHint: 'Przy jednej wartości ponowne przypisanie tagu wymaga potwierdzenia zastąpienia',
    autoCreate: 'Automatyczne tworzenie wartości',
    autoCreateOn: 'Przy przypisaniu',
    autoCreateOff: 'Tylko zadeklarowane',
    autoCreateHint: 'Włączone: przypisanie nowej wartości tworzy ją. Wyłączone: przypisać można wyłącznie wartości zadeklarowane',
    values: 'Wartości',
    noValues: 'Nie zadeklarowano żadnej wartości',
    addValue: 'Dodaj wartość',
    duplicateValue: 'Zduplikowana wartość',
    kinds: 'Typy zasobów',
    kindsAll: 'Wszystkie',
    kindsPlaceholder: 'Wszystkie',
    kindsHint: 'Puste pole dopuszcza każdy typ zasobu, który da się otagować',
    systemChip: 'System',
    deleteCascade: 'Usuń także przypisania',
    deleteCascadeHint: 'Tag wciąż przypisany do jakiegoś zasobu jest odrzucany: z tą opcją wartości i wszystkie przypisania znikają razem z tagiem.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Utwórz scope',
    editTitle: 'Zmień nazwę scope',
    path: 'Ścieżka',
    segment: 'Segment',
    segmentHint: 'Małe litery, cyfry i myślniki (DNS-1123)',
    parent: 'Nadrzędny',
    rootChip: 'Korzeń',
    preview: 'Nowy scope',
    pickLabel: 'Scope',
    pickHint: 'Gdzie obiekt żyje w drzewie klastra — w korzeniu albo w którymś z vDC wewnątrz niego.',
    ociCache: 'Cache OCI (nadpisanie)',
    appEphemeral: 'Efemeryczne pule aplikacji (nadpisanie)',
    inherit: 'Dziedzicz',
    inheritsFrom: 'Dziedziczy z',
    inheritsCluster: 'Dziedziczy domyślne ustawienie klastra',
    inheritsNone: 'Dziedziczy — brak efektywnej puli',
    failoverProtection: 'Ochrona w klastrze zdegradowanym',
    networkWeight: 'Waga sieci',
    networkCeil: 'Pułap sieci (Mbps)',
    protectionProtected: 'Chroniona',
    protectionExpendable: 'Do poświęcenia przy degradacji',
    protectionDefault: 'Domyślne klastra'
  },

  // System > Informacje (runda #124, 2026-07-31): wersje platformy we flocie
  // (najwyżej dwie w trakcie aktualizacji), komponenty każdego węzła, podręcznik
  // PDF serwowany lokalnie i wchłonięta karta licencji.
  sysinfo: {
    summary: 'Wersje platformy w klastrze, komponenty każdego węzła, podręcznik administracyjny i licencja.',
    platformTitle: 'Platforma TVirt',
    platformSubtitle: 'Wersje obserwowane na węzłach klastra',
    versionOnNodes: '{version} na węzłach: {n}',
    versionOnOneNode: '{version} na 1 węźle',
    mixedVersions: 'W klastrze jest więcej niż jedna wersja platformy — spodziewane wyłącznie podczas trwającej aktualizacji (najwyżej dwie).',
    tooManyVersions: 'W klastrze są więcej niż dwie wersje platformy — to nie jest spodziewane nigdy, nawet podczas aktualizacji: należy sprawdzić węzły poniżej.',
    unreportedNodes: 'Wciąż brak raportu wersji od: {nodes}',
    noVersionsYet: 'Żaden węzeł nie zaraportował jeszcze swoich wersji.',
    nodesUnavailable: 'Lista węzłów nie jest widoczna przy obecnych uprawnieniach — nie można pokazać wersji platformy.',
    colNode: 'Węzeł',
    manualTitle: 'Podręcznik administracyjny',
    manualSubtitle: 'Kopia lokalna, serwowana przez ten klaster',
    manualBody: 'Pełny podręcznik TVirt w PDF, serwowany bezpośrednio przez platformę — dostępny także w środowiskach air-gapped.',
    manualLink: 'Podręcznik administracyjny (PDF)',
    apiExplorerTitle: 'Eksplorator API',
    apiExplorerSubtitle: 'Kontrakt OpenAPI, do przeglądania',
    apiExplorerBody: 'Pełny kontrakt OpenAPI platformy — każda trasa, schemat i kod odpowiedzi — do przeglądania z przeglądarki, serwowany przez ten węzeł.',
    apiExplorerLink: 'Eksploruj API',
    kubeTitle: 'Zgodność z Kubernetes',
    kubeSubtitle: 'kubectl i jego narzędzia przed natywnym API',
    kubeBody: 'TVirt KubeCompat rzutuje Pody, Deploymenty, Service\'y, przestrzenie nazw, węzły i zdarzenia na dialekt Kubernetes — tylko do odczytu, plus usuwanie Deploymentów. Każde wywołanie przechodzi przez natywne API z Twoimi uprawnieniami: w kubeconfig użyj app tokenu jako bearer.',
    kubeEndpoint: 'Endpoint dla kubectl',
    kubeStatusActive: 'Aktywny — Kubernetes {version}',
    kubeStatusMissing: 'Nie zainstalowano na tym węźle (pakiet trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Zainstalowany, ale nie odpowiada — sprawdź jednostkę trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Sprawdzanie…'
  },

  // Licencjonowanie (runda 2026-07-29): strona licencji subskrypcyjnej.
  licensing: {
    title: 'Licencja klastra',
    subtitle: 'Licencja subskrypcyjna — najwyżej jedna na klaster',
    absentTitle: 'Nie zarejestrowano żadnej licencji',
    absentBody:
      'Bez ważnej licencji klaster odmawia uruchamiania nowych maszyn wirtualnych (włączone VM pozostają włączone). Należy zarejestrować klucz produktu otrzymany wraz z subskrypcją.',
    registerButton: 'Zarejestruj licencję',
    removeButton: 'Wyrejestruj licencję',
    state: {
      ok: 'Ważna',
      limitExceeded: 'Limit przekroczony',
      expired: 'Wygasła'
    },
    productKeyLabel: 'Klucz produktu',
    basisLabel: 'Podstawa limitu',
    basis: {
      concurrentVms: 'Jednocześnie włączone VM',
      physicalCores: 'Rdzenie fizyczne (łącznie w klastrze)'
    },
    limitLabel: 'Limit',
    usageLabel: 'Bieżące użycie',
    usageOf: '{used} z {limit}',
    usagePartial: 'suma częściowa — węzły bez zaobserwowanej topologii CPU: {n}',
    usageUnknown: 'chwilowo nieobserwowalne',
    expiresLabel: 'Wygasa',
    neverExpires: 'nigdy',
    registeredLabel: 'Zarejestrowano',
    gateNote:
      'Przy braku licencji, licencji wygasłej albo przekroczonym limicie klaster odmawia uruchamiania NOWYCH maszyn wirtualnych. Włączone VM pozostają włączone, a restarty HA nie są tym dotknięte.',
    devStage:
      'Faza rozwojowa: klucz produktu jest przyjmowany takim, jaki jest, wraz z zadeklarowanymi tutaj limitami; walidacja podpisanego klucza pojawi się w przyszłym wydaniu.',
    dialogTitle: 'Zarejestruj licencję',
    dialogExpiresHelp: 'Puste = licencja nigdy nie wygasa',
    dialogSubmit: 'Zarejestruj',
    dialogError: 'Nie można zarejestrować licencji.',
    removeTitle: 'Wyrejestruj licencję',
    removeBody:
      'Klaster zostanie BEZ LICENCJI: nowe maszyny wirtualne odmówią startu, dopóki nie zostanie zarejestrowana kolejna. Włączone VM pozostają włączone.',
    removeConfirm: 'Wyrejestruj',
    removeError: 'Nie można wyrejestrować licencji.'
  },
  rbac: {
    tabRoles: 'Role',
    tabGrants: 'Nadania',
    rolesTitle: 'Role',
    createRoleTitle: 'Utwórz rolę',
    editRoleTitle: 'Edytuj rolę',
    nameHint: 'Małe litery, cyfry i myślniki; prefiks tvirt- jest zarezerwowany',
    systemChip: 'System',
    permissions: 'Uprawnienia',
    permissionsPlaceholder: 'Dodaj uprawnienie…',
    includedRoles: 'Role zawarte',
    includedRolesPlaceholder: 'Dodaj rolę…',
    grantsTitle: 'Nadania',
    createGrantTitle: 'Utwórz nadanie',
    principal: 'Principal',
    principalKind: 'Typ principala',
    principalUser: 'Użytkownik',
    principalGroup: 'Grupa',
    role: 'Rola',
    grantRight: 'Delegowanie',
    grantRightChip: 'Może delegować',
    grantRightLabel: 'Z prawem delegowania (odbiorca może dalej delegować tę rolę)',
    effective: 'Obowiązuje',
    notEffective: 'Nie obowiązuje',
    createdAt: 'Utworzono',
    scopeHint: '/path dokładnie, /path/* rekurencyjnie — nadania kotwiczą się w zamontowanym korzeniu (/* nie podlega delegowaniu)'
  },
  groups: {
    title: 'Grupy',
    createTitle: 'Utwórz grupę',
    nameHint: 'Małe litery, cyfry i myślniki; unikalna w scope',
    members: 'Członkowie',
    membersTitle: 'Członkowie',
    membersPlaceholder: 'Dodaj użytkownika…',
    noMembers: 'Brak członków',
    realmMappings: 'Mapowania realm',
    realmMappingsTitle: 'Mapowania realm',
    realmMappingsHint:
      'Czemu odpowiada ta grupa w każdym zewnętrznym realm. Przynależność odczytuje się z katalogu w chwili logowania: grupa katalogowa, której nikt tutaj nie mapuje, jest ignorowana, a zagnieżdżenie nie jest rozwiązywane — trzeba je spłaszczyć po stronie katalogu.',
    realm: 'Realm',
    externalGroup: 'Grupa zewnętrzna',
    addRealmMapping: 'Dodaj mapowanie',
    removeRealmMapping: 'Odepnij mapowanie',
    noRealmMappings: 'Brak mapowań realm',

    // Dialog tworzenia podzielony na sekcje (runda realm-wizard, 2026-08-03):
    // Ogólne plus powierzchnia mapowania na zewnętrzne realm, z mówiącym
    // stanem pustym.
    sectionGeneral: 'Ogólne',
    mappingsNoRealms: 'Nie skonfigurowano żadnego zewnętrznego realm — powierzchnia mapowania odblokuje się, gdy tylko jakiś realm powstanie.',
    mappingsNoRealmsLink: 'Otwórz kartę Realm i SSO',

    // Wymóg MFA nakładany przez grupę (runda #178, połowa B): czyste OR —
    // grupa może wymóg tylko DODAĆ, nigdy go zdjąć.
    mfaRequired: 'Wymóg MFA',
    mfaRequiredChip: 'Wymusza MFA',
    mfaNotRequiredChip: 'Brak wymogu',
    mfaRequiredHint:
      'Czyste OR: grupa może DODAĆ wymóg drugiego składnika swoim członkom — także tożsamościom zewnętrznym, przez mapowania realm — nigdy go zdjąć. Obowiązuje od następnego logowania: otwarte sesje nie są zamykane.'
  },
  users: {
    title: 'Użytkownicy',
    createTitle: 'Utwórz użytkownika',
    editTitle: 'Edytuj użytkownika',
    username: 'Nazwa użytkownika',
    usernameHint: 'Małe litery, cyfry, kropki i myślniki',
    displayName: 'Nazwa wyświetlana',
    enabled: 'Włączony',
    state: 'Stan',
    enabledChip: 'Włączony',
    disabledChip: 'Wyłączony',
    lockedChip: 'Zablokowany',
    password: 'Hasło',
    passwordSetChip: 'Ustawione',
    mustChangeChip: 'Do zmiany',
    initialPassword: 'Hasło początkowe',
    initialPasswordHint: 'Użytkownik będzie musiał je zmienić przy pierwszym logowaniu',
    lastLogin: 'Ostatnie logowanie',
    neverLoggedIn: 'Nigdy się nie zalogował',
    setPasswordTitle: 'Ustaw hasło',
    setPasswordHint: 'Podmiana administracyjna — wymaga hasła operatora (tryb sudo) i zmusza użytkownika do zmiany hasła przy następnym logowaniu.',
    operatorPassword: 'Hasło operatora',
    unlock: 'Odblokuj konto',
    revokeTitle: 'Unieważnij sesje',
    revokeBody: 'Wszystkie aktywne sesje tego użytkownika zostają natychmiast zakończone.',
    revokeIncludeTokens: 'Unieważnij także app tokeny',
    revokeConfirm: 'Unieważnij',

    // Dialog standardowy (runda #156): pełne szczegóły, karty konto/bezpieczeństwo.
    tabAccount: 'Konto',
    tabSecurity: 'Bezpieczeństwo',
    usernameImmutableHint: 'Nazwa użytkownika jest tożsamością konta — ustalona przy tworzeniu',
    groups: 'Grupy',
    noGroups: 'Brak grup',
    mustChangePassword: 'Wymagana zmiana hasła',
    failedAttempts: 'Nieudane próby logowania',
    lockedUntil: 'Zablokowany do',

    // Karty tożsamości (2026-08-03): System > Użytkownicy stała się sekcją z
    // kartami na wzór /system/rbac — użytkownicy, grupy, zewnętrzne realm.
    tabUsers: 'Użytkownicy',
    tabGroups: 'Grupy',
    tabRealms: 'Realm i SSO',
    tabMfa: 'MFA',

    // Karta MFA (task #178, połowa A — GUI na istniejącym contract): widok
    // drugiego składnika dla każdego użytkownika. Konfiguracja tożsamości
    // zewnętrznych i stan osierocony to połowa B — runda contract, nigdy
    // formularz bez backendu.
    mfa: {
      title: 'Drugi składnik (MFA)',
      methodsTitle: 'Dostępne metody',
      methodsSubtitle: 'To, co ta instalacja potrafi zweryfikować jako drugi składnik',
      methodsError: 'Nie można wczytać rejestru metod',
      builtinChip: 'Wbudowana',
      enrollableChip: 'Konfiguracja w TVirt',
      delegatedChip: 'Zarządzana zewnętrznie',
      state: 'Stan',
      stateActive: 'Aktywny',
      statePending: 'Oczekuje na konfigurację',
      stateNone: 'Nieskonfigurowany',
      required: 'Wymóg MFA',
      requiredChip: 'Wymagany',
      notRequiredChip: 'Niewymagany',
      enrolledAt: 'Skonfigurowano',
      enrolledMethods: 'Skonfigurowane metody',
      noMethods: 'Brak konfiguracji',
      codesRemaining: 'Pozostałe kody odzyskiwania',
      resetTitle: 'Zresetuj drugi składnik',
      resetHint:
        'Konfiguracja i wszystkie kody odzyskiwania zostają wyzerowane: przy następnym logowaniu użytkownik skonfiguruje drugi składnik od nowa. Wymóg MFA pozostaje bez zmian — administrator nigdy nie ustawia sekretu, jedynie go zeruje.',
      resetConfirm: 'Zresetuj',
      resetError: 'Nie można zresetować drugiego składnika',
      empty: 'Nie ma jeszcze żadnego zarządzanego użytkownika — konta pojawią się tutaj, gdy tylko powstaną, każde ze swoim stanem drugiego składnika.',

      // Połowa B (runda #178): pochodzenie obowiązującego werdyktu, zewnętrzne
      // konfiguracje ze stanem osieroconym, grupy wymuszające wymóg.
      viaSelf: 'Osobisty',
      viaSelfHint: 'Osobisty wkład konta (jego flaga) — jedyna część, którą edytuje ołówek.',
      viaGroupHint: 'Wymóg odziedziczony z tej grupy: zdjęcie osobistej flagi nie uwalnia użytkownika — należy działać na grupie, na karcie Grupy.',
      subject: 'Tożsamość',
      lastSeenAt: 'Ostatnie potwierdzenie',
      enrollmentPending: 'W toku',
      orphanChip: 'Osierocona',
      orphanDirectoryMiss: 'Tożsamości nie ma już w katalogu',
      orphanRealmRemoved: 'Realm został usunięty z TVirt',
      orphanedAt: 'Osierocona od',
      directoryUuid: 'UUID w katalogu',
      externalTitle: 'Zewnętrzne konfiguracje',
      externalEmpty: 'Nie ma jeszcze żadnej zewnętrznej konfiguracji — powstaje przy pierwszym logowaniu tożsamości katalogowej objętej wymogiem MFA.',
      orphanHelp:
        'Osierocona konfiguracja nigdy nie usuwa się sama: to materiał bezpieczeństwa — zostaje dla audytu, a jeśli tożsamość znów pojawi się w katalogu, odnajduje swój składnik. Jedynym wyjściem jest reset administracyjny.',
      visibilityHint: 'Zewnętrzne konfiguracje rezydują w korzeniu klastra: widzi je tylko ten, kto ma user.read na całym drzewie.',
      orphanResetHint:
        'Osierocony wiersz zostaje usunięty na dobre: nikt już się o niego nie upomina. Jeśli tożsamość wróci do katalogu, skonfiguruje drugi składnik od nowa.',
      enforcingTitle: 'Grupy wymuszające MFA',
      enforcingSubtitle:
        'Kotwicą wymogu dla tożsamości zewnętrznych jest grupa: jej mapowania realm mówią, do której populacji katalogu dociera. Zewnętrzna konfiguracja powstaje przy pierwszym logowaniu zobowiązanego użytkownika.',
      enforcingEmpty: 'Żadna grupa nie wymusza MFA — wymóg włącza się na grupie, na karcie Grupy.',
      enforcingError: 'Nie można wczytać grup wymuszających MFA'
    }
  },
  realms: {
    title: 'Realm uwierzytelniania',
    createTitle: 'Utwórz realm',
    editTitle: 'Edytuj realm',
    name: 'Realm',
    nameHint: 'Domena, którą użytkownicy wpisują po znaku @ (example.com) — niezmienna po utworzeniu',
    nameImmutableHint: 'Nazwa realm jest wypisana w każdej sesji i w każdym wierszu audytu, który ją kiedykolwiek wymienił — jej zmiana przepisałaby historię',
    kind: 'Typ',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC i SAML pojawią się w kolejnych rundach — dziś realm to katalog LDAPv3',

    // Semi-kreator tworzenia (runda realm-wizard, 2026-08-03): karty typów z
    // kroku 1 — ldap żywy, oidc/saml jako karty w roadmapie (nigdy formularz
    // bez backendu za nim).
    kindCategory: 'Typ realm',
    kindSelectHint: 'Należy wybrać typ katalogu, w którym ten realm będzie uwierzytelniał.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Nazwa użytkownika i hasło weryfikowane bindem w katalogu LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on z przeglądarki delegowane do dostawcy tożsamości OpenID Connect — pojawi się w kolejnych rundach.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Firmowe single sign-on z asercjami SAML 2.0 — pojawi się w kolejnych rundach.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Włączony',
    urls: 'Serwery katalogu',
    urlsHint: 'Jeden URL ldap:// albo ldaps:// na wiersz (1–8), próbowane po kolei — failover, nigdy równoważenie',
    startTls: 'StartTLS',
    verifyCertificate: 'Weryfikuj certyfikat',
    cleartextWarning: 'Bez ldaps:// albo StartTLS hasło binda wędruje przez sieć otwartym tekstem — dopuszczalne w laboratorium, nigdy na produkcji.',
    noVerifyWarning: 'Niezweryfikowana sesja TLS nie uwierzytelnia nikogo: weryfikację wyłącza się wyłącznie wobec katalogu, którego nie da się naprawić.',
    caCertificate: 'Certyfikat CA (PEM)',
    caCertificateHint: 'Opcjonalny bundle CA przypięty do handshake TLS/StartTLS tego realm; puste pole go usuwa',
    caCertificatePinned: 'Przypięty',
    connectTimeout: 'Limit czasu (sekundy)',
    connectTimeoutHint: 'Termin na połączenie i żądanie dla każdego URL (1–60); po jego upływie próbowany jest kolejny URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Konto serwisowe, które wykonuje wyszukiwanie użytkownika; puste = anonimowy search bind (odrzucany przez AD)',
    anonymousBind: 'Anonimowy search bind',
    bindCredential: 'Hasło binda (keystore)',
    bindCredentialHint: 'Wpis usernamePassword w keystore z hasłem binda — sekret nigdy nie żyje na realm',
    bindCredentialNone: 'Brak (bind anonimowy)',
    bindCredentialEmpty: 'Brak wpisu usernamePassword w keystore — należy utworzyć jeden na hasło binda w sekcji System > Poświadczenia.',
    baseDn: 'Base DN',
    baseDnHint: 'Poddrzewo, od którego zaczyna się wyszukiwanie użytkownika (DC=example,DC=com)',
    userFilter: 'Filtr użytkownika',
    userFilterHint: '%u jest zastępowane lokalną częścią loginu, z escapowaniem wg RFC 4515; katalogi inne niż AD zwykle oczekują (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atrybut memberOf',
    memberOfAttributeHint: 'Odczytywany tylko raz, przy logowaniu — niezmapowane grupy są ignorowane, zagnieżdżenie nie jest rozwiązywane',
    uuidAttribute: 'Atrybut UUID',
    uuidAttributeHint: 'Niezmienny UUID w obrębie realm (objectGUID w AD, entryUUID w OpenLDAP) — wypisywany w audycie obok użytkownik@realm',
    displayNameAttribute: 'Atrybut nazwy wyświetlanej',
    displayNameAttributeHint: 'Używany do powitania użytkownika; w razie jego braku używana jest nazwa logowania',
    sudoHint: 'Zapisy na realm są chronione trybem sudo: realm to drzwi wejściowe do platformy',
    deleteBody: 'Mapowania grup realm odchodzą razem z nim; sesje, które uwierzytelnił, żyją do wygaśnięcia — usunięty realm po prostu nikogo już nie wpuszcza.',
    tabConnection: 'Połączenie',
    tabDirectory: 'Katalog',
    testTitle: 'Test połączenia',
    testHint: 'Sonda konfiguracji, nigdy uwierzytelnienie: łączy się, wykonuje bind kontem serwisowym i — jeśli podana jest nazwa użytkownika — uruchamia filtr użytkownika.',
    testUsername: 'Nazwa użytkownika (opcjonalnie)',
    testUsernameHint: 'Lokalna część, na której zostanie uruchomiony filtr użytkownika — 1 dopasowanie to zdrowa odpowiedź',
    testRun: 'Uruchom test',
    testError: 'Nie można wykonać sondy',
    testReachable: 'Katalog osiągalny, bind serwisowy przyjęty',
    testUnreachable: 'Katalog NIEOSIĄGALNY',
    matchedOne: 'Filtr użytkownika znalazł dokładnie 1 wpis — to zdrowa odpowiedź.',
    matchedNone: 'Filtr użytkownika nie znalazł żadnego wpisu: filtr albo base DN jest błędny.',
    matchedMany: 'Filtr użytkownika znalazł wpisów: {count} — nie jest selektywny, a logowania byłyby niejednoznaczne (odrzucane).',
    mappingsPointer: 'To, czemu odpowiada grupa zewnętrzna, jest właściwością grupy TVirt (jej mapowań realm): punkt prawdy żyje w karcie Grupy.',
    mappingsPointerLink: 'Otwórz kartę Grupy',
    rootHomeHint: 'Tożsamości z zewnętrznego realm żyją w korzeniu klastra, nigdy w vDC: uprawnienia przypisuje się tam, gdzie są potrzebne, za pomocą nadań — na grupie albo bezpośrednio na użytkowniku, dokładnie tak samo jak przy tożsamościach natywnych.'
  },
  credentials: {
    title: 'Poświadczenia',
    createTitle: 'Utwórz poświadczenie',
    editTitle: 'Edytuj poświadczenie',
    kind: 'Typ',
    kindUsernamePassword: 'Nazwa użytkownika i hasło',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (tożsamość Ceph)',
    kindHintUsernamePassword: 'Niezmienny. Dla storage CIFS/SMB — konto montujące, którego sekretu worker używa w chwili montowania.',
    kindHintIscsiChap: 'Niezmienny. Do uwierzytelniania CHAP iSCSI — nazwa użytkownika = nazwa CHAP, sekret = sekret CHAP.',
    kindHintNvmeDhchap: 'Niezmienny. Do DH-HMAC-CHAP w NVMe over Fabrics — sekret = blob DHHC-1:xx:…; nazwa użytkownika jest wyłącznie etykietą.',
    kindHintCephx: 'Niezmienny. Dla klientów Ceph — nazwa użytkownika = nazwa klienta (client.…), sekret = klucz base64.',
    kindImmutableHint: 'Typ jest niezmienny po utworzeniu — jego zmiana oznacza nowe poświadczenie.',
    username: 'Nazwa użytkownika',
    usernameChap: 'Nazwa CHAP',
    usernameNvme: 'Etykieta',
    usernameCephx: 'Nazwa klienta',
    usernameHint: 'Opcjonalne konto, do którego należy sekret',
    usernameHintChap: 'Nazwa CHAP, którą uwierzytelnia się initiator',
    usernameHintNvme: 'Nieużywana przez transport — dowolna etykieta na własne notatki',
    usernameHintCephx: 'Nazwa klienta cephx — prefiks client. jest tolerowany',
    secret: 'Sekret',
    secretHint: 'Tylko do zapisu: używany przez konsumentów, nigdy więcej niepokazywany.',
    secretHintNvmeDhchap: 'Tylko do zapisu: sekret DH-HMAC-CHAP hosta w postaci kanonicznej DHHC-1:xx:… — używany przez konsumentów, nigdy więcej niepokazywany.',
    secretHintCephx: 'Tylko do zapisu: klucz cephx w base64 — używany przez konsumentów, nigdy więcej niepokazywany.',
    secretEditHint: 'Puste pole zostawia sekret bez zmian — wypełnienie go rotuje.',
    createdAt: 'Utworzono',
    inUseError: "'{name}' jest przywoływane przez konfigurację pewnego storage — najpierw trzeba je tam odpiąć.",
    nameHint: 'Małe litery, cyfry i myślniki (DNS-1123); unikalna w scope',

    // Dialog samej rotacji (runda #156): sekret nigdy nie ma ołówka inline.
    rotateTitle: 'Rotuj sekret',
    rotateHint: 'Tylko do zapisu: nowy sekret zastępuje ten zapisany — konsumenci użyją go przy następnym montowaniu.',

    // Runda #159 (PKI): karty Certyfikaty i CA.
    tabSecrets: 'Sekrety',
    tabCertificates: 'Certyfikaty',
    tabAuthorities: 'Urzędy certyfikacji',
    certificatesTitle: 'Certyfikaty',
    authoritiesTitle: 'Urzędy certyfikacji',
    caCreateTitle: 'Nowa CA',
    certCreateTitle: 'Nowy certyfikat',
    caMode: 'Pochodzenie',
    caModeGenerate: 'Wygeneruj w TVirt',
    caModeImport: 'Importuj (klucz + certyfikat)',
    certMode: 'Pochodzenie',
    certModeIssue: 'Wystaw z CA w keystore',
    certModeImport: 'Importuj (klucz + certyfikat)',
    issuingCa: 'CA wystawiająca',
    issuingCaHint: 'Certyfikat rodzi się w scope swojej CA, z zarejestrowanym rodzicem',
    noCasHint: 'Brak CA w keystore — najpierw należy wygenerować albo zaimportować jakąś w karcie CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject CA: litery, cyfry, spacja, kropka, podkreślenie, myślnik',
    commonNameCertHint: 'OpenVPN rozpoznaje klientów po CN — powinien być unikalny w obrębie CA',
    days: 'Ważność (dni)',
    daysCaHint: '1–7300 dni; 3650 (10 lat) to wartość domyślna',
    daysCertHint: '1–3650 dni; 365 to wartość domyślna',
    keyType: 'Typ klucza',
    keyTypeHint: 'EC P-256 jest domyślne; RSA dla starszych konsumentów',
    usage: 'Zastosowanie',
    usageClient: 'Klient (clientAuth)',
    usageServer: 'Serwer (serverAuth)',
    usageHint: 'Extended key usage, dla którego certyfikat jest wystawiany',
    san: 'Nazwy alternatywne (SAN)',
    sanHint: 'Rozdzielone przecinkami; literalne adresy IP stają się wpisami IP:, reszta DNS:',
    keyPem: 'Klucz prywatny (PEM)',
    keyPemHint: 'Tylko do zapisu: przechowywany w keystore, nigdy więcej niepokazywany',
    certPem: 'Certyfikat (PEM)',
    certPemHint: 'Certyfikat publiczny, który tworzy parę z kluczem',
    certPemCaHint: 'Certyfikat CA, który tworzy parę z kluczem (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Wystawca',
    parentCa: 'CA wystawiająca',
    parentCaImported: 'Zaimportowany — wystawiony poza TVirt',
    serial: 'Numer seryjny',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Ważny od',
    validUntil: 'Ważny do',
    expiry: 'Wygasa',
    expired: 'Wygasły',
    expiresInDays: 'Wygasa za {days} dn.',
    revoked: 'Unieważniony',
    revokedAtLabel: 'Unieważniony dnia',
    revokeTitle: 'Unieważnij certyfikat',
    revokeAction: 'Unieważnij',
    revokeWarning: 'Unieważnienie jest ostateczne: numer seryjny trafia na listę CRL wystawiającej CA, a każdy konsument odrzucający unieważnione certyfikaty (przede wszystkim OpenVPN) odtrąci ten certyfikat. Cofnięcia unieważnienia nie ma.',
    exportPem: 'Eksportuj PEM',
    exportChain: 'Eksportuj bundle łańcucha',
    exportCrl: 'Eksportuj CRL',
    materialImmutableHint: 'Materiał X.509 jest niezmienny — trzeba wystawić go od nowa albo zaimportować ponownie',
    caInUseError: "'{name}' ma jeszcze żywe wystawione certyfikaty (albo przywołuje ją jakiś storage) — najpierw trzeba je unieważnić lub usunąć."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Rozmieszczenie, dostępność i powinowactwo — gdzie działają VM klastra i czy mają być włączone',
    loadError: 'Panel Proximity wymaga store klastra — stan floty jest teraz nieosiągalny',
    config: {
      title: 'Konfiguracja',
      subtitle: 'Polityka rozmieszczania na poziomie klastra',
      save: 'Zapisz',
      saveError: 'Konfiguracja została odrzucona',
      strategy: 'Strategia wyboru',
      strategy_leastUsedResources: 'Najmniej zużytych zasobów',
      strategy_leastVms: 'Najmniej VM',
      strategy_random: 'Losowa',
      strategyLeastUsedResourcesHint: 'Spośród ważnych kandydatów węzeł z największą pozostałą dostępną RAM (zaobserwowana całość − rezerwa hosta − włączone VM), a przy remisie zaangażowanie vCPU. Deterministyczna przy tych samych danych.',
      strategyLeastVmsHint: 'Spośród ważnych kandydatów węzeł z najmniejszą liczbą włączonych VM; remisy rozstrzyga nazwa. Deterministyczna przy tych samych danych.',
      strategyRandomHint: 'Jednostajnie losowa spośród ważnych kandydatów.',
      liveness: 'Próg żywotności węzłów (sekundy)',
      livenessHint: 'Członek milczący ponad próg jest nieosiągalny: wypada z rozmieszczania i — o ile nie jest w trybie konserwacji — decider HA uznaje go za martwego, odcina go i uruchamia jego VM z HA gdzie indziej.',
      decider: 'Decider HA',
      deciderNone: 'jeszcze nie wybrany'
    },
    nodesTitle: 'Węzły',
    nodesSubtitle: 'Żywotność i pojemność empiryczna — dostępna RAM = całość − baza − zaangażowana',
    nodeCol: 'Węzeł',
    stateCol: 'Stan',
    ramCol: 'RAM (całość − baza − zaangażowana)',
    usableCol: 'Dostępna',
    vmsCol: 'Obciążenie',
    neverSeen: 'nigdy nie widziany',
    freshChip: 'osiągalny',
    staleChip: 'nieosiągalny',
    attestedChip: 'potwierdzony jako wyłączony',
    ramFormula: 'całość − baza − zaangażowana',
    haTitle: 'Wysoka dostępność',
    haSubtitle: 'VM z flagą HA są "zawsze włączone": TVirt uruchamia je ponownie po każdym niezamówionym zatrzymaniu — na tym samym węźle z backoffem, na innym węźle, gdy ich własny umrze (tylko storage współdzielony).',
    haNone: 'Żadna VM nie ma jeszcze flagi HA — można ją włączyć tutaj albo w szczegółach VM.',
    haVmCol: 'Maszyna wirtualna',
    haStateCol: 'Stan',
    haRestartsCol: 'Restarty HA',
    haLastEventCol: 'Ostatnie zdarzenie',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'Zmiana HA została odrzucona',
    rules: {
      title: 'Reguły powinowactwa',
      createTitle: 'Nowa reguła Proximity',
      editTitle: 'Edytuj regułę',
      nameHint: 'Małe litery, cyfry i myślniki (etykieta DNS)',
      vms: 'Maszyny wirtualne',
      vmsHint: 'Co najmniej dwie VM — reguła wiąże to, gdzie działają jedne względem drugich',
      type: 'Typ',
      affinity: 'Powinowactwo (razem)',
      antiAffinity: 'Antypowinowactwo (osobno)',
      typeAffinityHint: 'VM muszą działać na TYM SAMYM węźle.',
      typeAntiAffinityHint: 'VM muszą działać na RÓŻNYCH węzłach — klasyczna para HA.',
      mode: 'Tryb',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Naruszenia odrzucają operację (uruchomienie, migrację, failover) mówiącym błędem.',
      modeSoftHint: 'Preferencja, nigdy blokada: rozmieszczenie naruszające regułę dochodzi do skutku z widocznym ostrzeżeniem.',
      satisfied: 'Rozmieszczenie',
      satisfiedYes: 'zgodne',
      satisfiedNo: 'naruszone',

      // Dialog standardowy (runda #156): naruszenia mają własny wiersz, nie tooltip.
      violations: 'Naruszenia',
      noViolations: 'Brak'
    },
    events: {
      title: 'Zdarzenia HA',
      subtitle: 'Dziennik dostępności — restarty, fencing, failover i uczciwe pominięcia',
      none: 'Jeszcze nic.',
      when: 'Kiedy',
      kind: 'Zdarzenie',
      target: 'Obiekt',
      detail: 'Szczegół',
      kindRestarted: 'restart HA',
      kindGaveUp: 'poddanie się (crash loop)',
      kindNodeAttested: 'węzeł odcięty',
      kindFailedOver: 'failover',
      kindNoCandidate: 'brak kandydata',
      kindStorageLocalSkip: 'pominięta (storage lokalny)',
      kindZombieFenced: 'zombie zakończony'
    }
  }
}
